import React from 'react';
import LandingPageFullWidthUploadPanelCTA from 'LandingPageFullWidthUploadPanelCTA';

const ConvertPdfToWordLandingPageFullWidthUploadPanel = () => (
  <div className="large-upload-panel-upload-section-wrapper">
    <div className="upload-wrap edit-pages-upload-wrap hide-for-photos">
      <form id="dropzoneUploader" className="uploader">
        <div className="alert alert-error uploader-error">Error</div>
        <div className="uploader-area edit-pages-uploader-area">
          <img
            src="/images/icon-pdf-to-doc-v2.png"
            alt="Document and Arrow Icon"
            className="large-upload-panel-pdf-to-word-icon"
          />
          <h3 className="large-upload-panel-header">
              Convert Your PDF to a Word Doc
          </h3>
          <p className="large-upload-panel-sub-header">
            And <strong>edit text</strong> just like you would on a Word document.
          </p>
          <LandingPageFullWidthUploadPanelCTA
            ctaId="uploadPDFLarge"
            ctaText="Upload a PDF to Convert"
          />
        </div>
      </form>
    </div>
  </div>
);

export default ConvertPdfToWordLandingPageFullWidthUploadPanel;



// WEBPACK FOOTER //
// ./src-react/ConvertPdfToWordLandingPage/ConvertPdfToWordLandingPageFullWidthUploadPanel.jsx